import React from "react";
import "./SectionBadge.css"

const SectionBadge = ({children}) => {
    return (
        <div className="section-badge">{children}</div>
    )
}
export default SectionBadge